import {
  Alert,
  Image,
  Modal,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useState } from "react";
import { globalStyles } from "../../styles/globalStyles";
import { FlatList, TouchableOpacity } from "react-native-gesture-handler";
import { useCallback } from "react";
import { API } from "aws-amplify";
import { updateUsers } from "../../src/graphql/mutations";

export default function ChooseAvatar({
  showAvatar,
  setShowAvatar,
  user,
  refresh,
}) {
  // fix this -- store the images somewhere else (not as urls!)
  const images = [
    {
      id: 1,
      link: "https://i.pinimg.com/564x/04/e2/be/04e2beb46ef795284e876f22a6937ae7.jpg",
    },
    {
      id: 2,
      link: "https://i.pinimg.com/564x/a5/57/b3/a557b3fedfb7c735136b193bdafb7783.jpg",
    },
    {
      id: 3,
      link: "https://i.pinimg.com/564x/3a/6c/f8/3a6cf834e4d00da98a0a1754e5452db9.jpg",
    },
    {
      id: 4,
      link: "https://i.pinimg.com/564x/11/6f/6a/116f6a2d97a0a3a091936b86b2f110a5.jpg",
    },
    {
      id: 5,
      link: "https://i.pinimg.com/564x/21/42/8c/21428cb0a13633599ae34ba7d8cbc6d7.jpg",
    },
    {
      id: 6,
      link: "https://i.pinimg.com/564x/b2/50/4e/b2504ed1872e18d4092fd448be99c3cb.jpg",
    },
    {
      id: 7,
      link: "https://i.pinimg.com/564x/b0/65/38/b06538f446ca30007a1864e9c30e2095.jpg",
    },
    {
      id: 8,
      link: "https://i.pinimg.com/564x/b4/c0/a3/b4c0a37bd754da49dc7b164be36f29bf.jpg",
    },
    {
      id: 9,
      link: "https://i.pinimg.com/564x/b4/78/a7/b478a74ab39571c751ddf1aad1be2287.jpg",
    },
    {
      id: 10,
      link: "https://i.pinimg.com/564x/ee/db/f1/eedbf1af18b753ec1849118a2382f9b8.jpg",
    },
    {
      id: 11,
      link: "https://i.pinimg.com/564x/06/03/e9/0603e949d20d07ee1fb5c24ee3fcd43f.jpg",
    },
    {
      id: 12,
      link: "https://i.pinimg.com/564x/3c/5b/e5/3c5be57656e4ba6a611b9e68cd73d7c1.jpg",
    },
    {
      id: 13,
      link: "https://i.pinimg.com/564x/39/d7/ff/39d7ffdb4f4055d3efad912a52f178e3.jpg",
    },
    {
      id: 14,
      link: "https://i.pinimg.com/564x/4e/53/89/4e538924ee22c5077ed18724dc71da95.jpg",
    },
    {
      id: 15,
      link: "https://i.pinimg.com/564x/fc/b0/4c/fcb04c9208cc6c71d3c83507e3121094.jpg",
    },
    {
      id: 16,
      link: "https://i.pinimg.com/564x/f5/fb/1d/f5fb1d3f18d2c247334660b7221f20e6.jpg",
    },
    {
      id: 17,
      link: "https://i.pinimg.com/564x/11/42/c2/1142c2d5ff8bc46d922889bd6a10498a.jpg",
    },
    {
      id: 18,
      link: "https://i.pinimg.com/564x/da/e0/69/dae069e56f4cc946ac68bb3a7269e37c.jpg",
    },
    {
      id: 19,
      link: "https://i.pinimg.com/564x/63/aa/3b/63aa3b815a6cbf517ecf63af5674c27c.jpg",
    },
    {
      id: 20,
      link: "https://i.pinimg.com/736x/5c/e3/cd/5ce3cd5e8c58551773d022686643c07f.jpg",
    },
  ];

  let defaultImage =
    "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-social-600nw-1677509740.jpg";
  if (user.data.getUsers.profilePicture != null)
    defaultImage = user.data.getUsers.profilePicture;
  const [avatarSelected, setAvatarSelected] = useState(defaultImage);
  let userName = user.data.getUsers.userName;
  userName = userName.toUpperCase();

  async function updateProfilePic() {
    try {
      await API.graphql({
        query: updateUsers,
        variables: {
          input: {
            uId: user.data.getUsers.uId,
            profilePicture: avatarSelected,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }
  return (
    <View style={{ alignItems: "center" }}>
      {showAvatar && (
        <Modal visible={showAvatar} animationType={"fade"} transparent={true}>
          <View
            style={
              Platform.OS == "web" ? styles.modalStyleWeb : styles.modalStyle
            }
          >
            <Text
              style={{
                ...globalStyles.titleText,
                fontSize: 25,
                marginBottom: 10,
              }}
            >
              Choose Your Avatar
            </Text>
            <FlatList
              numColumns={Platform.OS == "web" ? 5 : 3}
              data={images}
              keyExtractor={(item) => item.id}
              renderItem={({ item }) => (
                <TouchableOpacity
                  style={styles.pictureStyle}
                  onPress={() => {
                    setAvatarSelected(item.link);
                  }}
                >
                  <Image
                    source={{ uri: item.link, width: 70, height: 70 }}
                    style={styles.pictureStyle}
                  />
                </TouchableOpacity>
              )}
            />
            <View style={{ flexDirection: "row", justifyContent: "flex-end" }}>
              <Image
                source={{
                  uri: avatarSelected,
                  width: 100,
                  height: 100,
                }}
                style={styles.pictureStyle}
              />
              <View style={{ marginLeft: 40 }}>
                <Text style={{ ...globalStyles.titleText, fontSize: 27 }}>
                  {userName}
                </Text>
                <TouchableOpacity
                  style={{ marginTop: 5 }}
                  onPress={async () => {
                    await updateProfilePic();
                    setShowAvatar(false);
                    Alert.alert("Your profile picture has been updated!");
                    refresh();
                  }}
                >
                  <Text style={styles.buttonText}>SAVE</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Modal>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  modalStyle: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 200,
    marginBottom: 150,
    backgroundColor: "#a9d1de",
    marginHorizontal: 30,
    borderRadius: 20,
  },
  modalStyleWeb: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginVertical: "10%",
    backgroundColor: "#a9d1de",
    marginHorizontal: "20%",
    borderRadius: 20,
  },
  pictureStyle: {
    borderRadius: 400,
    marginHorizontal: 10,
    marginVertical: 5,
  },
  buttonText: {
    fontFamily: "quicksand-bold",
    fontSize: 20,
    letterSpacing: 2,
    color: "#e6685a",
  },
});
